module.exports = __webpack_public_path__ + "img/A1824F_4A2A06_F7E29F_B3A598-256px.092296fc.png";